import React from 'react'

import { colors } from '~tokens/internal'

interface EmailReceivedIconProps {
  width?: number
  height?: number
  alt?: string
  fill?: string
}

const EmailReceivedIcon: React.FC<EmailReceivedIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Email received icon',
  fill = colors.teal[50],
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-label={alt}
    >
      <title>{alt}</title>
      <g clipPath='url(#clip0_emailreceived)'>
        <path
          d='M19.4248 15.4004L17.8252 17H22V19H17.8252L19.4004 20.5996L18 22L14 18L18 14L19.4248 15.4004ZM20 3C20.55 3 21.0204 3.19622 21.4121 3.58789C21.8038 3.97956 22 4.45 22 5V12.7998C21.55 12.5332 21.0708 12.3335 20.5625 12.2002C20.0542 12.0669 19.5333 12 19 12C17.3333 12 15.9167 12.5833 14.75 13.75C13.5833 14.9167 13 16.3333 13 18V19H4C3.45 19 2.97956 18.8038 2.58789 18.4121C2.19622 18.0204 2 17.55 2 17V5C2 4.45 2.19622 3.97956 2.58789 3.58789C2.97956 3.19622 3.45 3 4 3H20ZM12 10L4 5V7L12 12L20 7V5L12 10Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_emailreceived'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EmailReceivedIcon
